<template lang="pug">
  .ui-tabs
    .tabs.is-marginless
      ul
        template(v-for="item,index in items")
          router-link(v-if="item.route" tag="li" :key="index" :to="item.route")
            a
              b-icon(v-if="item.icon" :icon="item.icon")
              span {{ item.label }}
          li(v-else :class="{'is-active': value == index || item.active}" @click="selectTab(index)")
            a
              b-icon(v-if="item.icon" :icon="item.icon")
              span {{ item.label }}

      //- Действия
      .tab-actions(v-if="(actions && actions.length) || $slots.actions")
        slot(name="actions")

        template(v-if="actions && actions.length" v-for="act,index in actions")
          b-tooltip(v-if="act.tooltip" :label="act.tooltip" position="is-left")
            ui-button.is-primary(:to="act.route" :icon="act.icon" :label="act.label" exact)
          ui-button.is-primary(v-else :to="act.route" :icon="act.icon" :label="act.label" exact)

      slot(name="end")

    .tab-content: slot
</template>

<script>
export default {
  name: 'ui-tabs',

  props: {
    items: Array,
    actions: Array,
    value: Number,
  },

  methods: {
    selectTab(index) {
      this.$emit('input', index);
    },
  },
};
</script>
